import { api } from "./api";

export const configApi = {
  listPortfolios: () => api.get("/portfolios"),
  createPortfolio: (body) => api.post("/portfolios", body),
  updatePortfolio: (id, body) => api.patch(`/portfolios/${id}`, body),
  deactivatePortfolio: (id) => api.patch(`/portfolios/${id}`, { status: "inactive" }),
  listSites: () => api.get("/sites"), createSite: (body) => api.post("/sites", body),
  updateSite: (id, body) => api.patch(`/sites/${id}`, body), deactivateSite: (id) => api.patch(`/sites/${id}`, { status: "inactive" }),
  listBlocks: (params) => api.get("/config/blocks", { params }), createBlock: (body) => api.post("/config/blocks", body),
  updateBlock: (id, body) => api.patch(`/config/blocks/${id}`, body), deactivateBlock: (id) => api.delete(`/config/blocks/${id}`),
  listFlats: (params) => api.get("/config/flats", { params }), createFlat: (body) => api.post("/config/flats", body),
  updateFlat: (id, body) => api.patch(`/config/flats/${id}`, body), deactivateFlat: (id) => api.delete(`/config/flats/${id}`),
  listRooms: (params) => api.get("/config/rooms", { params }), createRoom: (body) => api.post("/config/rooms", body),
  updateRoom: (id, body) => api.patch(`/config/rooms/${id}`, body), deactivateRoom: (id) => api.delete(`/config/rooms/${id}`),
  listRoomTypes: (params) => api.get("/config/room-types", { params }),
  createRoomType: (body) => api.post("/config/room-types", body),
  updateRoomType: (id, body) => api.patch(`/config/room-types/${id}`, body),
};

export const accessApi = {
  roles: () => api.get("/roles"), catalogue: () => api.get("/permissions/catalogue"),
  createRole: (body) => api.post("/roles", body), updateRole: (id, body) => api.patch(`/roles/${id}`, body),
  deleteRole: (id) => api.delete(`/roles/${id}`), users: () => api.get("/users"), createUser: (body) => api.post("/users", body),
  updateUser: (id, body) => api.patch(`/users/${id}`, body), removeUser: (id) => api.delete(`/users/${id}`),
  previewUserImport: (body) => api.post("/config/users/import/preview", body),
  importUsers: (body) => api.post("/config/users/import", body),
  requestPasswordRecovery: (id, requirePasswordChange = true) => api.post(`/users/${id}/password-recovery`, { require_password_change: requirePasswordChange }),
};
